import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "rsuite";
import CheckRoundIcon from "@rsuite/icons/CheckRound";
import "./CorridorSuccessModal.scss";

const CorridorSuccessModal = ({ onClose }) => {
  return (
    <Modal
      className="corridor-success-modal"
      open={true}
      size="xs"
      backdrop="static"
      onClose={onClose}
    >
      <Modal.Body>
        <div className="success-content">
          <div className="success-icon" data-testid="success-icon">
            <CheckRoundIcon style={{ fontSize: 48 }} />
          </div>
          <p className="success-message">
            Your request has been received and will be actioned by our team in
            the next 24 hours.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button appearance="primary" className="close-btn" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

CorridorSuccessModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default CorridorSuccessModal;
